import { Table, Input, Button, Select } from "antd";
import { PlusOutlined, LeftOutlined, BulbOutlined } from "@ant-design/icons";

const EmployeeGroup = () => {
  const columns = [
    {
      title: "Group Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Group Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Total Employees",
      dataIndex: "employees",
      key: "employees",
    },
  ];

  const data = [
    {
      key: "1",
      code: "01",
      name: "General",
      employees: 100,
    },
  ];

  return (
    <div className="px-4 pt-2 pb-4 flex flex-col gap-5 bg-white rounded-md">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold mb-4">Employee Group </h2>
        <div className="flex justify-between items-center gap-2">
          <Button icon={<LeftOutlined />}>Back</Button>
          <Button icon={<BulbOutlined />}>Page Tip</Button>
        </div>
      </div>
      <div className="flex gap-4">
        <div className="flex-1 space-x-4">
          <Input.Search placeholder="Search" style={{ width: 300 }} />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            className="bg-primary text-white"
          >
            Create a New
          </Button>
        </div>
        <div className="flex items-center gap-2 mr-0">
          <span>Show</span>
          <Select defaultValue="10" options={[{ value: "10", label: "10" }]} />
          <span>Entries</span>
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="keys"
        scroll={{ x: 'max-content' }}
        pagination={{
          total: data.length,
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} items`,
        }}
        className="bg-white rounded-lg border border-gray-200"
      />
      <div className="flex justify-between items-center mt-4"></div>
    </div>
  );
};

export default EmployeeGroup;
